module.exports = __webpack_public_path__ + "img/9.85203364.svg";